$(document).on('turbolinks:load', () =>{
  if ($('textarea').length > 0) {
    var data = $('#ckeditor');
    $.each(data, function(i) {
      CKEDITOR.replace(data[i].id)
    });
  }
});